<template>
  <section class="admin-content" id="contact-search">
    <Navbar />
    <main class="admin-main">
      <div class="bg-dark m-b-30">
        <div class="container">
          <div class="row p-b-60 p-t-60">
            <div class="col-md-6 text-center mx-auto text-white p-b-30">
              <h3 class="h4 text-white">Claims</h3>
            </div>
          </div>
        </div>
      </div>
      <section class="">
        <div class="container">
          <div class="row">
            <div class="col-md-4">
              <div class="card m-b-30 bg-info">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="mdi mdi-file-document-outline"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="h4">Claims</p>
                    <h1 class="fw-400">
                      {{ claimsTotal | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card m-b-30 bg-default">
                <div class="card-body text-dark">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="fe fe-credit-card"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="h4">Amount Requested</p>
                    <h1 class="fw-400">
                      <i class="mdi mdi-currency-ngn"></i
                      >{{ totalRequestedCost | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4">
              <div class="card m-b-30 bg-dark">
                <div class="card-body text-white">
                  <div class="pb-2">
                    <div class="avatar avatar-lg">
                      <div class="avatar-title bg-soft-info rounded-circle">
                        <i class="fe fe-database"></i>
                      </div>
                    </div>
                  </div>
                  <div>
                    <p class="h4">Amount Approved</p>
                    <h1 class="fw-400">
                      <i class="mdi mdi-currency-ngn"></i
                      >{{ totalApprovedCost | numeral(0, 0) }}
                    </h1>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 text-sm">
              *Data Presented above are based on selected filers
            </div>
          </div>
          <div class="col-md-12">
            <div class="card" v-show="filterparams">
              <div class="card-header">
                <p class="text-center h4">Filter Parameter</p>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="form-group col-md-6">
                    <label for="inputEmail4">Claim ID</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="claim_unique_id"
                      placeholder="CLM_xxxxx"
                    />
                  </div>
                  <div class="form-group col-md-6">
                    <label for="inputPassword4">Authorization Code</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="authorization_code"
                      placeholder="AUT_xxxxxxxx"
                    />
                  </div>

                  <div class="form-group col-md-6">
                    <label for="inputEmail4">OHIS Number</label>
                    <input
                      type="text"
                      class="form-control"
                      v-model="id_card_number"
                      placeholder="OHIS/xx/xxxxx"
                    />
                  </div>

                  <div
                    class="form-group col-md-6"
                    v-if="user.type == 'shis' || user.type == 'employee'"
                  >
                    <label> Select Facility </label>

                    <v-select
                      v-model="provider_id"
                      label="agency_name"
                      :options="providers"
                      @change="getClaims(1)"
                    />
                  </div>

                  <div class="form-group col-md-6">
                    <label> Select Status </label>
                    <select class="form-control" v-model="claim_status">
                      <option value="">All</option>
                      <option value="approved">Approved</option>
                      <option value="vetted">Vetted</option>
                      <option value="verified">Verified</option>
                      <option value="pending">Pending</option>
                      <option value="draft" v-if="user && (user.type == 'provider' || user.type == 'provider_employee')">Draft</option>
                      <option value="rejected">Rejected</option>
                    </select>
                  </div>
                  <div class="form-group col-md-3">
                    <label for="inputCity"
                      ><i class="fe fe-calendar"></i> Start Date
                    </label>
                    <input type="date" class="form-control" v-model="from" />
                  </div>

                  <div class="form-group col-md-3">
                    <label for="inputCity"
                      ><i class="fe fe-calendar"></i> End Date
                    </label>
                    <input type="date" class="form-control" v-model="to" />
                  </div>
                  <div class="col-md-12">
                    <button
                      class="btn btn-outline-dark btn-block"
                      @click="getClaims(1)"
                    >
                      Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <br />

          <div class="card row list">
            <div class="card-header">
              <button class="btn btn-outline-dark float-left">
                {{ claims.length }} {{ provider_id.agency_name }} Claims
              </button>

              <button
                class="btn btn-outline-dark float-right"
                @click="filterparams = !filterparams"
              >
                filters
              </button>

              <button
                style="margin-right: 4px"
                class="btn btn-outline-primary float-right"
              >
                <download-excel
                  :data="claims.data"
                  :fields="json_fields"
                  type="xls"
                  :escapeCsv="false"
                  :name="'claims_data' + '.xls'"
                >
                </download-excel>
              </button>
            </div>
            <div class="card-body m-b-30">
              <div class="table-responsive">
                <table class="table align-td-middle table-card">
                  <thead>
                    <tr>
                      <th>SN</th>
                      <th>Health Facility</th>
                      <th>Patient</th>
                      <th>Diagnosis</th>
                      <th>Requested / Approved</th>
                      <th>Status</th>
                      <th>Date Created</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(claim, index) in claims.data"
                      v-bind:key="claim.id"
                    >
                      <td>{{ serialNumber(index) }}</td>
                      <td>
                        <span v-if="claim.provider">{{
                          claim.provider.agency_name
                        }}</span>
                      </td>
                      <td>
                        <span v-if="claim.enrollee != null">
                          {{ claim.enrollee.full_name }} (
                          {{ claim.enrollee.id_card_number }} )
                        </span>
                      </td>

                      <td>
                        <span v-if="claim.diagnosis != null"
                          >{{ claim.diagnosis.name }}
                        </span>
                      </td>
                      <td>
                        <i class="mdi mdi-currency-ngn"></i>
                        {{ claim.requested_total_cost | numeral(0, 0) }} /
                        <i class="mdi mdi-currency-ngn"></i>
                        {{ claim.approved_total_cost | numeral(0, 0) }}
                      </td>
                      <td>
                        <span
                          v-for="payment in claim.paymentorders"
                          :key="payment"
                        >
                          <button
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                          >
                            {{ payment.status }}
                          </button>
                        </span>

                        <span v-if="claim.status == 1">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-success"
                          >
                            approved
                          </button>
                        </span>

                        <span v-if="claim.verified_by_id != null">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-info"
                          >
                            verified
                          </button>
                        </span>
                        <span v-if="claim.checked_by_id != null">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                          >
                            vetted
                          </button>
                        </span>
                        <span v-if="claim.status == 0">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-danger"
                          >
                            rejected
                          </button>
                        </span>
                        <span v-if="claim.status == 2">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-dark"
                          >
                            draft
                          </button>
                        </span>
                        <span v-if="claim.status == null">
                          <button
                            type="button"
                            class="btn m-b-15 ml-2 mr-2 badge badge-soft-warning"
                          >
                            pending
                          </button>
                        </span>
                      </td>
                      <td>
                        {{ claim.created_at | moment("dddd, MMMM Do YYYY") }}
                      </td>
                      <td>
                        <a :href="`/claim/` + claim.id " target="_blank">
                          <button
                            type="button"
                            name="button"
                            class="btn btn-outline-dark"
                          >
                            <i class="fe fe-eye"></i>
                          </button>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td colspan="4">
                        <div
                          class="col-md-12"
                          v-if="user.job_title == 'Claims Verifier'"
                        >
                          <b-alert show variant="primary">
                            To forward claims to the ES for approval, select a
                            facility
                          </b-alert>
                        </div>
                      </td>
                    </tr>
                    <tr
                      v-if="
                        user.job_title == 'Claims Verifier' &&
                        provider_id != '' &&
                        claims.data.length != 0
                      "
                    >
                      <td colspan="4">
                        <button
                          class="btn btn-outline-dark btn-block"
                          @click="forwwardClaims()"
                        >
                          Forward {{ provider_id.agency_name }}'s Claims to the
                          ES for Approval
                          <i class="fe fe-send"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div
                class="d-flex flex-wrap justify-content-between align-items-center mt-3"
                v-if="claims.pagination && claims.pagination.last_page > 1"
              >
                <small class="text-muted">
                  Showing {{ startItemIndex }} - {{ endItemIndex }} of
                  {{ claimsTotal | numeral(0, 0) }} claims
                </small>

                <div class="btn-group mt-2 mt-md-0" role="group">
                  <button
                    class="btn btn-outline-dark"
                    :disabled="currentPage <= 1 || isLoading"
                    @click="getClaims(currentPage - 1)"
                  >
                    Previous
                  </button>

                  <button
                    v-for="page in visiblePages"
                    :key="`page-${page}`"
                    class="btn"
                    :class="
                      page === currentPage
                        ? 'btn-dark'
                        : 'btn-outline-dark'
                    "
                    :disabled="isLoading"
                    @click="getClaims(page)"
                  >
                    {{ page }}
                  </button>

                  <button
                    class="btn btn-outline-dark"
                    :disabled="
                      currentPage >= claims.pagination.last_page || isLoading
                    "
                    @click="getClaims(currentPage + 1)"
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            loader="dots"
            :can-cancel="true"
            :is-full-page="fullPage"
          ></loading>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import Navbar from "@/views/Navbar.vue";
// Import component
import Loading from "vue-loading-overlay";
// Import stylesheet
import "vue-loading-overlay/dist/vue-loading.css";
// Init plugin

import moment from "moment";
moment().format();

export default {
  components: {
    Navbar,
    Loading,
  },
  data() {
    return {
      user: null,
      claims: {
        data: [],
        // [
        //   {
        //     id: "",
        //     requested_total_cost: "",
        //     approved_total_cost: "",
        //   },
        // ],
      },
      selected: "",
      claim_unique_id: "",
      authorization_code: "",
      id_card_number: "",
      edit: false,
      show: false,
      filterparams: false,
      showsearch: false,
      isLoading: false,
      fullPage: true,
      paginate_value: 100,
      currentPage: 1,
      from: moment().subtract(30, "days").format("YYYY-MM-DD"),
      to: moment().format("YYYY-MM-DD"),
      providers: "",
      tpas: "",
      claim_status: "",
      org_id: "",
      provider_id: "",
      date: "",
      json_fields: {
        "Enrollee Full Name": "enrollee.full_name",
        "Enrollee OHIS Number": "enrollee.id_card_number",
        "Enrollee Sector": "enrollee.sector",
        "Enrollee Phone Number": "enrollee.phone_number",
        Diagnosis: "diagnosis.name",
        "Authorization Code": "authorization_code",
        "Requested Amount": "requested_total_cost",
        "Approved / Verified Amount": "approved_total_cost",
        "Date Requested": "created_at",
        "Date Vetted": "checked_by_date",
        "Date Verified": "verified_by_date",
        "Facility Name": "provider.agency_name",
      },

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  beforeCreate() {
    // this.from = this.getThreeMonths();
    // this.to = this.getCurrentDate();
  },
  beforeMount() {
    this.user = JSON.parse(localStorage.getItem("user"));
  },
  computed: {
    claimsTotal() {
      if (this.claims.pagination && this.claims.pagination.total != null) {
        return this.claims.pagination.total;
      }

      return this.claims.data ? this.claims.data.length : 0;
    },
    perPage() {
      if (this.claims.pagination && this.claims.pagination.per_page) {
        return this.claims.pagination.per_page;
      }

      return this.paginate_value;
    },
    startItemIndex() {
      if (!this.claims.data || this.claims.data.length === 0) {
        return 0;
      }

      return (this.currentPage - 1) * this.perPage + 1;
    },
    endItemIndex() {
      if (!this.claims.data || this.claims.data.length === 0) {
        return 0;
      }

      return Math.min(
        this.startItemIndex + this.claims.data.length - 1,
        this.claimsTotal
      );
    },
    visiblePages() {
      if (!this.claims.pagination || !this.claims.pagination.last_page) {
        return [1];
      }

      const lastPage = this.claims.pagination.last_page;
      const start = Math.max(1, this.currentPage - 2);
      const end = Math.min(lastPage, this.currentPage + 2);
      const pages = [];

      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      return pages;
    },
    totalRequestedCost() {
      if (this.claims.data) {
        return this.claims.data.reduce((sum, item) => {
          return sum + item.requested_total_cost;
        }, 0);
      } else {
        return 0;
      }
    },
    totalApprovedCost() {
      if (this.claims.data) {
        return this.claims.data.reduce((sum, item) => {
          return sum + item.approved_total_cost;
        }, 0);
      } else {
        return 0;
      }
    },
  },
  methods: {
    serialNumber(index) {
      return (this.currentPage - 1) * this.perPage + index + 1;
    },
    setClaimsResponse(payload, { filterRequestedCost = false } = {}) {
      const payloadObject = Array.isArray(payload) ? { data: payload } : payload;
      const claimsPayload = payloadObject || { data: [] };
      const sourceData = Array.isArray(claimsPayload.data)
        ? claimsPayload.data
        : [];
      const data = filterRequestedCost
        ? sourceData.filter((item) => item.requested_total_cost > 0)
        : sourceData;

      const paginationSource = claimsPayload.pagination || {};
      const currentPage = Number(
        paginationSource.current_page || claimsPayload.current_page || 1
      );
      const perPage = Number(
        paginationSource.per_page ||
          claimsPayload.per_page ||
          this.paginate_value ||
          data.length ||
          1
      );
      const total = Number(
        paginationSource.total || claimsPayload.total || data.length
      );
      const lastPage = Number(
        paginationSource.last_page ||
          claimsPayload.last_page ||
          Math.max(1, Math.ceil(total / perPage))
      );

      this.claims = {
        ...claimsPayload,
        data,
        pagination: {
          current_page: currentPage,
          per_page: perPage,
          total,
          last_page: lastPage,
        },
      };
      this.currentPage = currentPage;
    },
    getClaims(page = 1) {
      this.user = JSON.parse(localStorage.getItem("user"));
      this.currentPage = page;

      const params = {
        claim_status: this.claim_status,
        claim_unique_id: this.claim_unique_id,
        authorization_code: this.authorization_code,
        id_card_number: this.id_card_number,
        org_id: this.org_id,
        date: this.date,
        from: this.from,
        to: this.to,
        page: this.currentPage,
        per_page: this.paginate_value,
      };

      if (this.user.type == "shis" || this.user.type == "employee") {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/claims/95930`, {
            params: {
              ...params,
              provider_id:
                this.provider_id && this.provider_id.id
                  ? this.provider_id.id
                  : "",
            },
          })
          .then((response) => {
            this.setClaimsResponse(response.data);
            console.log(response);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }
      if (this.user.type == "provider") {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/claminByProvider${this.user.id}`, {
            params,
          })
          .then((response) => {
            this.setClaimsResponse(response.data, { filterRequestedCost: true });

            console.log(response);
            this.isLoading = false;
          })
          .catch((error) => {
            console.error(error);
            this.isLoading = false;
          });
      }
      if (this.user.type == "provider_employee") {
        this.isLoading = true;
        this.axios
          .get(`/api/v1/auth/claminByProvider${this.user.institutional_id}`, {
            params,
          })
          .then((response) => {
            this.setClaimsResponse(response.data);
            this.isLoading = false;
            console.log(response);
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    getProviders() {
      this.axios
        .get(`/api/v1/auth/providerAgency/95930`)
        .then((response) => {
          this.providers = response.data.data;
          console.log(response);
        })
        .catch((error) => {
          console.error(error);
        });
    },

    forwwardClaims() {
      if (confirm("Are you sure you want to Forward")) {
        this.isLoading = true;
        this.axios
          .post(`/api/v1/auth/forwardclaimtoES`, {
            claims: this.claims.data,
          })
          .then((response) => {
            console.log(response);
            this.isLoading = false;
            this.$toasted.info("Forwarded Successfully!", {
              position: "top-center",
              duration: 3000,
            });
          })
          .catch((error) => {
            this.isLoading = false;
            console.error(error);
          });
      }
    },
  },
  created() {
    this.getClaims();
    this.getProviders();
  },
};
</script>
<style scoped>
.spacer-side {
  margin-left: 3px;
  margin-right: 3px;
}
</style>
